// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_array from "../../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";

function getVehicleTracerDefaultTime(vehicleLocation, polylinesInfo) {
  return Belt_Option.flatMap(polylinesInfo, (function (polyline) {
                if (vehicleLocation) {
                  return Caml_option.some(Caml_array.get(polyline.line, polyline.line.length - 1 | 0).ts);
                } else {
                  return Caml_option.some(Caml_array.get(polyline.line, 0).ts);
                }
              }));
}

function getVehicleDefaultLocation(vehicleLocation, polylinesInfo) {
  return Belt_Option.flatMap(polylinesInfo, (function (polyline) {
                if (vehicleLocation) {
                  return Caml_array.get(polyline.line, polyline.line.length - 1 | 0).point;
                } else {
                  return Caml_array.get(polyline.line, 0).point;
                }
              }));
}

export {
  getVehicleTracerDefaultTime ,
  getVehicleDefaultLocation ,
  
}
/* No side effect */
